import {
	Button,
	ColourStateSolid,
	FlexAlign,
	ItemRow,
	ItemRowCell,
	ItemRowHeader,
	StackHorizontal,
	StackVertical,
	Surface,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatCurrency } from '@ukpostbox/helpers';
import { CourierLogos } from './CourierLogos';
import { ShippingOptionsResultGroupType, ShippingOptionType } from '../Types/ShippingOptionsTypes';

function ShippingOptionsResultGroup(props: ShippingOptionsResultGroupType) {
	const { t } = useTranslation();

	return (
		<Surface
			extraClass='mb-xl pb-xs shipping-options-rows'
			key={`shippingGroup${Math.floor(Math.random() * (20000 - 19000 + 1) + 19000)}`}
		>
			<StackVertical extraClass='sticky'>
				<StackHorizontal align={FlexAlign.Center} extraClass='p-md glass'>
					<CourierLogos value={props.title} />
					<h5 className='mb-0 ml-md'>{props.title === 'Royal' ? 'Royal Mailboxes' : props.title}</h5>
				</StackHorizontal>

				<ItemRowHeader title='Shipping Options' extraClass='shipping-options-row-header' inCard sidePadding>
					<ItemRowCell extraClass='pl-md'>{t('shippingCalculator.headings.description')}</ItemRowCell>
					<ItemRowCell>{t('shippingCalculator.headings.deliveryTime')}</ItemRowCell>
					<ItemRowCell extraClass='text-right'>{t('shippingCalculator.headings.cost')}</ItemRowCell>
					<ItemRowCell extraClass='text-right pr-md'>{t('shippingCalculator.headings.vat')}</ItemRowCell>
				</ItemRowHeader>
			</StackVertical>

			{props.data.map((item: ShippingOptionType) => (
				<ItemRow
					title={`Shipping Options Entry ${item.description}`}
					key={`shippingOption-${item.description}`}
					static
					extraClass='shipping-options-item-row'
					inCard
					sidePadding
				>
					<ItemRowCell extraClass='pl-md'>{item.description}</ItemRowCell>
					<ItemRowCell>{item.durationDescription}</ItemRowCell>
					{item.cost > 0 ? (
						<>
							<ItemRowCell extraClass='text-right'>{FormatCurrency(item.cost)}</ItemRowCell>
							<ItemRowCell extraClass='text-right pr-md'>{FormatCurrency(item.costWithTax)}</ItemRowCell>
						</>
					) : (
						<div style={{ gridColumn: 'span 2', paddingInlineEnd: 'var(--sm-unit)' }}>
							<ItemRowCell>
								<Button
									onClick={() => props.callback()}
									title='Contact Us'
									colour={ColourStateSolid.Primary}
									fullWidth
								/>
							</ItemRowCell>
						</div>
					)}
				</ItemRow>
			))}
		</Surface>
	);
}

export { ShippingOptionsResultGroup };
